import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore

export default [
]
